import { SURVEY_STATUS } from './data';

export class SurveyConverter {
  convertStatus(data) {
    const questions = (data?.questions ?? [])
      .map(item => ({
        id: item.question_id,
        text: item.question,
        position: +item.position,
        choices: (item.choices ?? [])
          .map(choice => ({
            id: choice.choice_id,
            text: choice.choice,
            position: +choice.position,
          }))
          .sort((a, b) => a.position - b.position),
      }))
      .sort((a, b) => a.position - b.position);

    return {
      status: Number(data?.agent_survey_status ?? SURVEY_STATUS.NOT_STARTED),
      surveyId: data?.survey?.survey_id ?? null,
      currentQuestionId: data?.current_question_id ?? null,
      questions,
    };
  }
}
